import { orderBySingleField } from "../libs/arrayUtils";

export const useOrderTemplates = (
  templates, orderByDate = false, orderAlphabetically, orderAlphabeticallyReverse, keyOrder
) => {
  return orderByDate
    ? orderBySingleField(
      templates, "insertTimestamp", false
    )
    : orderAlphabetically
      ? orderBySingleField(templates, `${keyOrder}`)
      : orderAlphabeticallyReverse
        ? orderBySingleField(
          templates, `${keyOrder}`, false
        )
        : templates;
};
